export default __webpack_public_path__ + "static/media/offer1.5e21f305.png";